import axios from "axios";
import { IAPIResponse } from "../../types/IAPIResponse";
import { IOption } from "../../types/Codes/IOptions";
import {
  ApplicationTempletesEmail,
  EmailTempleteDto,
  NewEmailTempleteDto,
} from "../types/EmailTempletes";

export class TempletesEmailAPI {
  async GetAllTempletes(registrar: boolean): Promise<IAPIResponse<IOption[]>> {
    const response = await axios.get<IAPIResponse>(
      "/admin/templates/email/getAllTempletes/" + registrar
    );
    let templetes: IAPIResponse<IOption[]> = response.data;
    return Promise.resolve(templetes);
  }

  async GetATemplete(
    id: number
  ): Promise<IAPIResponse<ApplicationTempletesEmail>> {
    const response = await axios.get<IAPIResponse>(
      "/admin/templates/email/getatemplete/" + id
    );
    let templetes: IAPIResponse<ApplicationTempletesEmail> = response.data;
    return Promise.resolve(templetes);
  }

  async UpdateATemplete(
    data: EmailTempleteDto
  ): Promise<IAPIResponse<ApplicationTempletesEmail>> {
    const response = await axios.put<IAPIResponse>(
      "/admin/templates/email/updatetemplete/",
      data
    );
    let templetes: IAPIResponse<ApplicationTempletesEmail> = response.data;
    return Promise.resolve(templetes);
  }

  async CreateATemplete(
    data: NewEmailTempleteDto
  ): Promise<IAPIResponse<ApplicationTempletesEmail>> {
    const response = await axios.post<IAPIResponse>(
      "/admin/templates/email/createatemplete/",
      data
    );
    let templetes: IAPIResponse<ApplicationTempletesEmail> = response.data;
    return Promise.resolve(templetes);
  }
}
